module.exports = __webpack_public_path__ + "static/media/V-img2.7d572ea5.png";